import {Component, OnInit} from '@angular/core';
import {Reservation, ReservationsService, ReservationType} from "../../../services/reservations.service";
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmReservationModalComponent} from "./modals/confirm-reservation-modal.component";
import {RejectReservationModalComponent} from "./modals/reject-reservation-modal.component";
import "rxjs/add/operator/filter";
import {ActivatedRoute, Router} from "@angular/router";


@Component({
  selector: 'reservations-list',
  templateUrl: 'reservations-list.component.html'
})
export class ReservationsListComponent implements OnInit {
  reservations: Reservation[];

  reservationType: ReservationType;
  ReservationType = ReservationType;

  constructor(
    private reservationsService: ReservationsService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.reservationType = <ReservationType>this.route.snapshot.queryParamMap.get('type') || ReservationType.UPCOMING;
    this.fetchData();
  }

  private fetchData() {
    this.reservationsService
      .getReservationsList(this.reservationType)
      .subscribe(data => this.reservations = data);
  }

  showConfirmModal(reservation: Reservation) {
    ConfirmReservationModalComponent
      .open(this.modalService, reservation)
      .filter(result => result)
      .subscribe(_ => this.fetchData());
  }

  showRejectModal(reservation: Reservation) {
    RejectReservationModalComponent
      .open(this.modalService, reservation)
      .filter(result => result)
      .subscribe(_ => this.fetchData());
  }

  selectReservationType(reservationType: ReservationType) {
    this.reservationType = reservationType;
    this.router.navigate([], {queryParams: {type: reservationType}});
    this.fetchData();
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/reservations-list/reservations-list.component.ts